import { apiRequest } from "../utils/apiClient";

export const fetchUserList = async (Search: string) => {
  const response = await apiRequest("/api/users/userList", "POST", {
    Search,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const updateUser = async (
  user:any
) => {

  const response = await apiRequest("/api/users/updateUser", "POST", {
    ...user
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};

export const deleteUser = async (user_id: string) => {
  const response = await apiRequest("/api/users/deleteUser", "POST", {
    user_id,
  });

  if (response.status !== 200) {
    throw new Error(response.message);
  }

  return response.data;
};
